import { useEffect, useState, FC } from 'react';
import {httpClient} from "../../../util/Api";
import {useLogin} from "../../../hooks/services/auth/useLogin";
import {useBaseQuery} from "../../../hooks/services/base/useBaseQuery";
import { setInitUrl } from "../../../appRedux/actions";
import { useDispatch } from "react-redux";
export const useProvideAuth = (isExpired) => {
  const { mutate: onLogin } = useLogin();
  const [authUser, setAuthUser] = useState(null);
  const [error, setError] = useState('');
  const [isLoadingUser, setLoadingUser] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const {clearQueries} = useBaseQuery();
  const fetchStart = () => {
    setLoading(true);
    setError('');
  };
  const dispatch = useDispatch();


  useEffect(()=>{
    setAuthUser({tokenExpired : isExpired,
      userInfo : null});
  },[isExpired]);

  const fetchSuccess = () => {
    setLoading(false);
    setError('');
  };

  const fetchError = (error) => {
    setLoading(false);
    setError(error);
  };

  const userLogin = (user, callbackFun) => {
    fetchStart();
    clearQueries();
    onLogin(user, {
       onSuccess: (data) => {
        fetchSuccess();
        localStorage.removeItem('token');
        localStorage.setItem('token', data.result.jwtToken);
        setAuthUser({tokenExpired :false,
          userInfo : data.result});
       },
       onError: (err) => {
        fetchError("نام کاربری یا رمز عبور اشتباه است");
       }
    })

  };


  const renderSocialMediaLogin = () => null;

  const userSignOut = (callbackFun) => {
    dispatch(setInitUrl('/'));
    httpClient.defaults.headers.common['Authorization'] = '';
    localStorage.removeItem('token');
    setAuthUser({tokenExpired :true,
      userInfo : null});
  };

  // Return the user object and auth methods
  return {
    isLoadingUser,
    isLoading,
    authUser,
    error,
    setError,
    setAuthUser,
    userLogin,
    userSignOut,
    renderSocialMediaLogin
  };
};
